import "./Welcome.css";

import { useContext, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import { useHistory } from "react-router";

const Welcome = () => {
  const { textosState } = useContext(PortalContext);
  const [view, setView] = useState(true);
  const history = useHistory();
  // Cierra para siempre
  const aceptar = async () => {
    localStorage.setItem("welcomeActive", "false");
    setView(false);
    history.push("videoTutoriales");
  };
  const cancelar = () => {
    localStorage.setItem("welcomeActive", "false");
    setView(false);
  };

  if (view) {
    return (
      <>
        <div className="sombra-welcome"></div>
        <div className="ptur-covidProto-container">
          <div className="ptur-covidProto-header bgcG-latex30">
            <h1 className="rb24t">Bienvenido al Portal</h1>
          </div>
          <div className="ptur-covidProto-body">
            <span
              className="span-bold123"
              dangerouslySetInnerHTML={{
                __html: `${
                  textosState.textos.data?.msjBienvenida?.descripcion
                    ? textosState.textos.data?.msjBienvenida?.descripcion
                    : "Loading ..."
                }`,
              }}
            />
          </div>
          <div className="ptur-welcome-containerBtn">
            <button className="ptur-welcome-btn" onClick={cancelar}>
              Ver luego
            </button>
            <button className="bgc-latex10" onClick={aceptar}>
              Ver videos
            </button>
          </div>
        </div>
      </>
    );
  } else {
    return "";
  }
};

export default Welcome;
